export class ListTituloService {
  constructor(httpClient) {
    this.httpClient = httpClient
  }

  async handle(params) {
    return await this.httpClient.get('/v01/Titulo/Titulos', { params })
  }
}
